import * as Repositories from '../../repositories/repositories'
import {ClientStateContextRepository} from "../../quoteWizard/repositories/clientStateContext.repository";
import {ClientStateContextSearchDetailViewModel} from "./clientstatecontextSearchDetail.viewmodel";
import {ClientStateContext} from "../../quoteWizard/clientstatecontext.model";
import {Phone, UserProfile} from "../../models/models";


export class ClientStateContextSearchDetailGateway {

    static $inject = ['$q', '$log',  'userRepository','clientStateContextRepository','phoneRepository'];

    constructor(private $q: ng.IQService,
                private $log: ng.ILogService,
                private userRepository: Repositories.UserRepository,
                private clientStateContextRepository:ClientStateContextRepository,
                private phoneRepository:Repositories.PhoneRepository
    ) { }

    public loadClientStateContextSearchDetailViewModel(clientStateContextId : string): ng.IPromise<ClientStateContextSearchDetailViewModel> {

          let clientStateContextSearchDetailViewModel = new ClientStateContextSearchDetailViewModel();

          return this.clientStateContextRepository.getClientStateContextById(clientStateContextId)
              .then((clientStateContext: ClientStateContext)=>{
                  clientStateContextSearchDetailViewModel.clientStateContext = clientStateContext;
                  return clientStateContextSearchDetailViewModel;})
              .then((viewModel:ClientStateContextSearchDetailViewModel)=>{
                  return this.setPrimaryContact(viewModel);
              })
              .then((viewModel:ClientStateContextSearchDetailViewModel)=>{
                  return this.setPrimaryContactPhone(viewModel);
              });
    }
    private setPrimaryContact (viewModel:ClientStateContextSearchDetailViewModel) : ng.IPromise<ClientStateContextSearchDetailViewModel> {

        return this.userRepository.getById(viewModel.clientStateContext.userId)
            .then((user:UserProfile) =>{
                viewModel.primaryContact = user;
                return viewModel;
            });

    }
    private setPrimaryContactPhone (viewModel:ClientStateContextSearchDetailViewModel): ng.IPromise<ClientStateContextSearchDetailViewModel>{

        return this.phoneRepository.getPhoneNumberByUserId(viewModel.primaryContact.id)
            .then((phone:Phone)=>{
                    viewModel.primaryContactPhone = phone;
                    return viewModel;
                }
            )
    }
}